export default __webpack_public_path__ + "f42f15d976dd60cd2928b6a4d7a28f2b.png";